/**
 * Auto-generated from dark-roast DAOs (com.axiom.db.models.dao).
 * Shared by all Java backends — do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Entity } from '@data-client/rest';
export class CandidateLanguageEntity extends Entity {
  createdAt: string | null = null;
  id: string = '';
  languageCEFR: string | null = null;
  languageId: string | null = null;
  languageProficiency: string | null = null;
  languageSkill: string | null = null;
  updatedAt: string | null = null;
  name?: string | null = null;
  static override key = 'CandidateLanguage';
  static override schema = {};
  static override toJSON() {
    return { name: this.name, schema: {}, key: this.key };
  }
  static override process(input: unknown): unknown {
    if (
      input !== null &&
      typeof input === 'object' &&
      'CandidateLanguage' in input
    ) {
      const { CandidateLanguage: wrapped, ...rest } = input as {
        CandidateLanguage: object;
      } & object;
      return { ...(wrapped as object), ...rest };
    }
    return input;
  }
}